import Axios from "axios";
import auth from "../../utils/auth";

// import Vue from 'vue';
const state = {
	settings: localStorage.getItem("betika-cashout-settings")
		? JSON.parse(localStorage.getItem("betika-cashout-settings"))
		: null,
	whitelisted: false,
};

const persistSettings = (settings) => {
	localStorage.setItem("betika-cashout-settings", JSON.stringify(settings));
};

const getters = {
	settings: (state) => {
		return state.settings ? state.settings : null;
	},
	whitelisted: (state) => {
		return state.whitelisted;
	},
};

const mutations = {
	initSettingsFromAPI(state) {
		if (auth.getAuthStatus()) {
			const profile_id = auth.getUser()["id"];
			const token = auth.getToken();
			Axios.get(`${BASE_V2_URL}cashout/whitelist?profile_id=${profile_id}`, {
				headers: { Authorization: token },
			})
				.then((res) => {
					state.whitelisted = true;
					Axios.get(`${BASE_V2_URL}cashout/validations`).then((res) => {
						state.settings = res.data;
						persistSettings(res.data);
					});
				})
				.catch((err) => {
					state.whitelisted = false;
				});
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
};
